<div style="display: flex; height: 100%;">
  <div style="min-width: 780px; height:100%; display: flex; align-items: flex-start; justify-content: center; font-size: 16px; margin-top: 140px">
    <div style="width: 400px;">
      <form [formGroup]="loginForm">
        <div>
          <div style="width: 100%; display: flex; justify-content: center; padding: 15px 0;">
            <img *ngIf="!isDarkMode()" style="width: 217px;" src="/assets/images/lexbe-logo-new.svg" />
            <img *ngIf="isDarkMode()" style="width: 217px;" src="/assets/images/lexbe-logo-dark-theme-3.svg" />
          </div>
          <div style="padding: 36px 0; text-align: center;">
            <span style="font-weight: 500;">Welcome back!</span>
          </div>
          <div>
            <div>
              <mat-form-field class="full-width blue-primary-outline-1 gold-outline-1 error-outline" appearance="outline">
                <input id="username-input" class="mat-body-strong" matInput placeholder="Email" formControlName="username" autocomplete="username">
                <mat-error *ngIf="loginForm.controls['username'].hasError('required')">
                  Email is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="full-width blue-primary-outline-1 gold-outline-1 error-outline" appearance="outline">
                <input id="password-input" class="mat-body-strong" type="password" matInput placeholder="Password" formControlName="password" autocomplete="password">
                <mat-error *ngIf="loginForm.controls['password'].hasError('required')">
                  Password is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>

            <div style="font-size: 14px; display: flex; justify-content: space-between; align-items: center; ">
              <div style="padding: 10px 0;">
                <mat-checkbox formControlName="rememberUsername">Remember email.</mat-checkbox>
              </div>
              <div style="padding: 10px 0;">
                <a class="forgot-password-link" style="font-weight: 500; text-decoration: none;" routerLink="/identity/forgot-password">Having
                  trouble signing in?</a>
              </div>
            </div>
            <div *ngIf="hasError">
              <strong class="sign-in-error" style="font-size: 12px;">There was an issue signing in. Please check your
                password and try again.</strong>
            </div>
            <div style="padding: 15px 0;">
              <button id="sign-in-button" style="display: flex; align-items: center; justify-content: center; width: 100%; height: 45px; border-radius: 3px;" mat-raised-button color="primary" (click)="onSubmit()">
                <span *ngIf="!isLoading">Sign In</span>
                <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div style="display: flex; flex-grow: 1; align-items: center; justify-content: center; background: url('/assets/images/login-bg-circles.png')">
    <div style="min-width: 730px; width: 100%; max-width: 935px;">
      <a href="https://lexbe.com/lexbeplatformtraining">
        <img style="width: 100%; box-shadow: 0px 3px 7px rgba(0, 0, 0, 0.25);" [src]="(loginPosterUrl$ | async) || 'assets/images/login-poster-20230325.png'" alt="lexbe poster about training" />
      </a>
    </div>
  </div>
</div>